import styled from 'styled-components';

import Heading from 'components/_core/Heading';

export const Container = styled.div`
  width: 410px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: ${({ theme }) => theme.spacings.abs16}px auto 0 auto;
`;

export const Img = styled.img`
  width: 180px;
  height: 180px;
  margin-top: ${({ theme }) => theme.spacings.abs40}px;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const Title = styled(Heading).attrs({ size: 'lg' })`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs24}px;
`;

export const CtaButtonContainer = styled.div`
  width: 310px;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;
